import { render } from "./beta-announcement.vue?vue&type=template&id=325b3ea6&scoped=true"
import script from "./beta-announcement.vue?vue&type=script&lang=js"
export * from "./beta-announcement.vue?vue&type=script&lang=js"

import "./beta-announcement.vue?vue&type=style&index=0&id=325b3ea6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325b3ea6"]])

export default __exports__